const __WEBPACK_NAMESPACE_OBJECT__ = require("@fontsource/inter/500.css");